import { render, staticRenderFns } from "./Order_partner_edit.vue?vue&type=template&id=06f97678&scoped=true&"
import script from "./Order_partner_edit.vue?vue&type=script&lang=js&"
export * from "./Order_partner_edit.vue?vue&type=script&lang=js&"
import style0 from "./Order_partner_edit.vue?vue&type=style&index=0&id=06f97678&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f97678",
  null
  
)

export default component.exports